import React, { useEffect, useState } from "react";
import { getLabelName } from "./Utils";
import { PreFilterParamsReadOnly } from "./JobReadOnly";
import PreFilterTable from "../PreFilters/PreFilterTable";
import { columnOperatorData, operatorData } from "../PreFilters/operatorData";
import Label from "../../FormComponents/Label";
import PreFilterJoinedBy from "../PreFilters/PreFilterJoinedBy";
import { hasOwn } from "../../../commonFunctions/arrayFunc";

const GetPrefiltersParamsData = ({
  keyName,
  smId,
  params,
  isReadOnly,
  // tableData,
  // templateObject,
  // device,
  editJobData,
  setParams,
  preRequirements,
  allFieldsObject,
  setEditJobData
  // actId,
  // type,
  // jobTemplateName
}) => {
  const [isLoading, setIsLoading] = useState(true);

  const paramsSelector = (key, data) => {
    if (!hasOwn(params, keyName) || typeof params[keyName] !== "object") {
      return;
    }
    const newParams = { ...params };
    newParams[keyName] = { ...newParams[keyName], [key]: data };

    setParams(newParams);
    setEditJobData(null);
  };

  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      if (editJobData) {
        setParams({ ...params, [keyName]: editJobData.params[keyName] });
      } else {
        setParams({
          ...params,
          [keyName]: {
            filters: [],
            pre_filter_join_by: ""
          }
        });
      }
      setIsLoading(false);
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params[preRequirements[preRequirements.indexOf(keyName) - 1]]]);
  if (isLoading) return;
  return (
    <>
      <PrefilterParamsData
        keyName={keyName}
        label={getLabelName(keyName)}
        onChange={(key, data) => paramsSelector(key, data)} //e, key
        isReadOnly={isReadOnly}
        params={params}
        smId={smId}
        allFieldsObject={allFieldsObject}
      />
    </>
  );
};

const PrefilterParamsData = ({ keyName, label, onChange, isReadOnly, params, allFieldsObject }) => {
  if (isReadOnly) {
    return (
      <PreFilterParamsReadOnly label={label} params={params} keyName={keyName} allFieldsObject={allFieldsObject} />
    );
  }
  return (
    <>
      <div className="builder_form">
        <Label>{`Select ${label}`}</Label>
        <PreFilterJoinedBy
          prefiltersJoinedBy={params[keyName].pre_filter_join_by}
          setPrefiltersJoinedBy={(formula) => onChange("pre_filter_join_by", formula)}
        />
        <PreFilterTable
          preFilters={params[keyName].filters || []}
          setPreFilters={(data) => onChange("filters", data)}
          // tableId={smId}
          tableId={params.sm_id}
          operatorList={[...operatorData, ...columnOperatorData]}
          tableObj={allFieldsObject}
        />
      </div>
    </>
  );
};

export default GetPrefiltersParamsData;
